/**
 * Envía datos a la URL especificada y maneja la respuesta.
 *
 * @param {object} data - Los datos que se enviarán.
 * @param {function} setSendtoExcel - Una función para establecer el estado de envío de datos a Excel.
 * @param {function} setModal - Una función para establecer el estado del modal.
 * @param {function} setResponse - Una función para establecer los datos de respuesta.
 */
const send_data = (data, setSendtoExcel, setModal, setResponse) => {
  setSendtoExcel(true);
  const url =
    "https://script.google.com/macros/s/AKfycbwfac8RDFnDMcnoMVo-tRRVTtRb4_Y6yuQ7ql44Tkc8QK73nITK3qb3jeulHpAX7JhIOg/exec";
  const temp = data.Campaña;
  data.Campaña = data.Pagaduria;
  data.Pagaduria = temp;

  fetch(url, {
    method: "POST",
    mode: "no-cors",
    body: new URLSearchParams(data),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then(() => console.log("Solicitud enviada"))
    .then((data) => {
      setSendtoExcel(false);
      setModal(true);
      // setResponse(data['row']);
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  fetch("https://n8n.ccgrupo.cloud/webhook/cbc87f53-28cd-4dd0-94ee-f515760fc5d1", {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then(() => console.log("Webhook n8n enviado"))
    .catch((error) => console.error("Error webhook n8n:", error));

  let channels = [];

  if (data["Enviar SMS de canal de whastapp"] === "SI") {
    channels.push("sms");
  }

  if (data["Enviar WhatsApp de recuperar contraseña"] === "SI") {
    channels.push("whatsapp");
  }

  channels = channels.join(",");

  const raw = JSON.stringify({
    nombre: data["Nombre del Cliente"],
    telefono: data["Telefono"],
    pagaduria: data["Pagaduria"],
    idWolkvox: data["IdWolkvox"],
    channels: channels,
  });
  if (channels.length == 0) return;
  console.log(raw);

  fetch("https://ccgrupo.ccgltda.com/dibanka/insert/insert.php", {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
  })
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
};

export { send_data };
